import { observable } from 'mobx'

class Store {
	@observable activeFilters
	@observable userName
	@observable appPagesComplete
	@observable activePage
	@observable appProgress

	constructor() {
		this.activeFilters = {
			blogFilter: {
				activeYear: '',
				activeCountry: '',
				activeDivision: '',
				activePage: 1,
				featured: 'featured'
			},
			fellowsFilter: {
				activeYear: '',
				activeCountry: '',
				activeDivision: '',
				activePage: 1,
				featured: 'featured'
			},
			teamFilter: {
				activeDivision: '',
				activePage: 1
			}
		}
		this.appPagesComplete = {}
		this.activePage = 1
		this.userName = ''
		this.appPages = observable([
			{
				id: 0,
				complete: false,
				title: 'Account',
				zapUrl: 'https://hooks.zapier.com/hooks/catch/1060428/j44ui5/',
				oribi_ref: 0
			},
			{
				id: 20,
				complete: false,
				title: 'Experience',
				zapUrl: 'https://hooks.zapier.com/hooks/catch/1060428/jsayq2/',
				oribi_ref: 2
			},
			{
				id: 30,
				complete: false,
				title: 'Personal',
				zapUrl: 'https://hooks.zapier.com/hooks/catch/1060428/jsaob7/',
				oribi_ref: 3
			},
			{
				id: 40,
				complete: false,
				title: 'Scholarships',
				zapUrl: 'https://hooks.zapier.com/hooks/catch/1060428/jsab2q/',
				oribi_ref: 4
			},
			{
				id: 50,
				complete: false,
				title: 'References',
				zapUrl: 'https://hooks.zapier.com/hooks/catch/1060428/jsabrq/',
				oribi_ref: 5
			},
			{
				id: 60,
				complete: false,
				title: 'Your Story',
				zapUrl: 'https://hooks.zapier.com/hooks/catch/1060428/jsably/',
				oribi_ref: 6
			},
			{
				id: 999,
				complete: false,
				title: 'Submit',
				oribi_ref: 7
			}
		])
		this.appProgress = {
			page0: {
				complete: false
			},
			page1: {
				complete: false
			},
			page2: {
				complete: false
			},
			page3: {
				complete: false
			},
			page4: {
				complete: false
			},
			page5: {
				complete: false
			},
			page6: {
				complete: false
			},
			page7: {
				complete: false
			}
		}
	}

	init(data) {
		this.data = data.data
	}
}

const store = new Store()

export default store



// WEBPACK FOOTER //
// ./src/Store.js